import { get } from 'lodash';
import { setList, createUpdateItem, setSelected, removeItem, setOrder } from './paymentSlice';
import { setList as setListCPCApplications, setIndividualList, setNonIndividualList,
  setExistingFranchiseList, setAuthorizedDriversList, setRequirementList,
  setAppointmentList, setReappointmentList, setPaymentFeesList, createUpdateItem as createUpdateCPCApplication,
  setPaymentTransactionList, setServiceUnitsList  } from '../application/applicationSlice';

import api, { normalize } from 'api';

export const getList = (params, callback) => async dispatch => {

  
  try{
    const response = await api.get('site/payments', { params: { ...params } })
    
    if(response){
      
      const reponseWithMeta = normalize(response, { endpoint: 'payments' })
      
      const order = get(reponseWithMeta, 'meta.payments.data', []).map(x => x.id)
      const payments = reponseWithMeta.payments || {}
      const cpc_applications = reponseWithMeta.cpc_applications || {}
      const cpc_individual_applications = reponseWithMeta.cpc_individual_applications || {}
      const cpc_non_individual_applications = reponseWithMeta.cpc_non_individual_applications || {}
      const appointments = reponseWithMeta.appointments || {}
      const reappointments = reponseWithMeta.reappointments || {}
      const payment_fees = reponseWithMeta.payment_fees || {}
      const payment_transactions = reponseWithMeta.payment_transactions || {}
      dispatch([
        setList(payments),
        setOrder(order),
        setAppointmentList(appointments),
        setReappointmentList(reappointments),
        setListCPCApplications(cpc_applications),
        setIndividualList(cpc_individual_applications),
        setNonIndividualList(cpc_non_individual_applications),
        setPaymentFeesList(payment_fees),
        setPaymentTransactionList(payment_transactions)
      ])
    }
  }catch(e){
    console.log(e)
  }
  
} 

export const view = (id) => async dispatch => {
  try{
    const response = await api.get(`site/payments/${id}`)
    
    if(response){
      const payments = normalize(response).payments || {}
      const cpc_applications = normalize(response).cpc_applications || {}
      const cpc_individual_applications = normalize(response).cpc_individual_applications || {}
      const cpc_non_individual_applications = normalize(response).cpc_non_individual_applications || {}
      const cpc_application_existing_franchises = normalize(response).cpc_application_existing_franchises || {}
      const cpc_application_authorized_drivers = normalize(response).cpc_application_authorized_drivers || {}
      const cpc_application_service_units = normalize(response).cpc_application_service_units || {}
      const application_requirements = normalize(response).application_requirements || {}
      const appointments = normalize(response).appointments || {}
      const reappointments = normalize(response).reappointments || {}
      const payment_fees = normalize(response).payment_fees || {}
      const payment_transactions = normalize(response).payment_transactions || {}
      
      dispatch([
        createUpdateItem(payments),
        createUpdateCPCApplication(cpc_applications),
        setIndividualList(cpc_individual_applications),
        setNonIndividualList(cpc_non_individual_applications),
        setExistingFranchiseList(cpc_application_existing_franchises),
        setAuthorizedDriversList(cpc_application_authorized_drivers),
        setRequirementList(application_requirements),
        setAppointmentList(appointments),
        setReappointmentList(reappointments),
        setPaymentFeesList(payment_fees),
        setPaymentTransactionList(payment_transactions),
        setServiceUnitsList(cpc_application_service_units)
      ])
    }
  }catch(e){
    console.log(e)
  }
  
} 

export const reuploadRequirement = (payment_id, requirement_id, payload, callback) => async dispatch => {
  try{
    const response = await api.put(`site/payments/${payment_id}/cpc/requirements/${requirement_id}`, payload)
    const application_requirements = normalize(response).application_requirements || {}
    if(response){
      callback(application_requirements)
    }
  }catch(e){
    console.log(e)
  }
}

export const resubmitApplication = (payment_id, callback) => async dispatch => {
  try{
    const response = await api.put(`site/payments/${payment_id}/cpc_new_application/resubmit`)
    
    if(response){
      if(callback)
        callback()
    }
  }catch(e){
    console.log(e)
  }
}


export const setAppointment = (payment_id, payload, callback) => async dispatch => {
  try{
    const response = await api.put(`site/payments/${payment_id}/cpc_new_application/set_appointment`, payload)
    
    if(response){

      if(callback){
        callback()
      }
    }
  }catch(e){
    console.log(e)
  }
}

export const create = (payload, callback) => async dispatch => {
  try{
    const response = await api.post('site/payments', payload)
    if(response){
      const payments = normalize(response).payments || {}
      await dispatch(createUpdateItem(payments))

      if(callback)
        await callback(payments)
    }
  }catch(e){
    console.log(e)
  }
  
} 


export const payNow = (id, callback) => async dispatch => {
  try{
    const response = await api.post(`site/payments/${id}`)
    
    const payments = normalize(response).payments || {}
    // await dispatch(createUpdateItem(payments))

    if(callback)
      await callback(payments)
  }catch(e){
    console.log(e)
  }
} 

export const show = setSelected

export const remove = (id, callback) => async dispatch => {
  try{
    const response = await api.delete(`site/payments/${id}`)
  
    await dispatch(removeItem(id))

    if(callback)
      await callback(response)
  }catch(e){
    console.log(e)
  }
} 
